import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_FULL } from "@/lib/constants";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

import { tx, lz } from "@/i18n";
export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error(tx("Wachtwoord moet minstens 6 tekens zijn"));
    if (password !== confirm) return toast.error(tx("Wachtwoorden komen niet overeen"));
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(tx("Wachtwoord bijgewerkt! Je kunt nu inloggen."));
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <Link to="/login" className="inline-flex items-center mb-8">
          <img src={LOGO_FULL} alt={tx("Costa Key")} className="h-11 w-auto object-contain" />
        </Link>
        {!token ? (
          <div data-testid="reset-no-token">
            <h1 className="font-display font-bold text-2xl tracking-tight">{tx("Ongeldige link")}</h1>
            <p className="text-muted-foreground mt-2">{tx("Deze herstellink is ongeldig of onvolledig. Vraag een nieuwe aan.")}</p>
            <Link to="/forgot-password" className="inline-flex items-center gap-1.5 text-primary font-semibold mt-6" data-testid="request-new-link">
              <ArrowLeft className="h-4 w-4" /> {tx("Nieuwe link aanvragen")}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            <h1 className="font-display font-bold text-3xl tracking-tight">{tx("Nieuw wachtwoord")}</h1>
            <p className="text-muted-foreground mt-1 mb-6">{tx("Kies een nieuw wachtwoord voor je account.")}</p>
            <div className="space-y-4">
              <div>
                <Label htmlFor="password">{tx("Nieuw wachtwoord")}</Label>
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="reset-password-input" />
              </div>
              <div>
                <Label htmlFor="confirm">{tx("Herhaal wachtwoord")}</Label>
                <Input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="reset-confirm-input" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full mt-6 bg-primary hover:bg-primary/90" data-testid="reset-submit-btn">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {tx("Wachtwoord opslaan")}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
